import React, { Component } from "react";
import { connect } from "react-redux";
import { func, shape, arrayOf, bool, string } from "prop-types";
import { Field, Form, withFormik } from "formik";
import Col from "react-bootstrap/lib/Col";
import { compose } from "redux";
import Button from "pages/_components/Button";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import Selector from "pages/_components/fields/formik/Selector";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import { push } from "connected-react-router";
import PageLoading from "pages/_components/PageLoading";
import { selectors as accountsSelectors, actions as accountsActions } from "reducers/accounts";
import { types } from "pages/echeck/constants";
import { shortFormatAccountLabel } from "util/format";
import { actions as notificationActions } from "reducers/notification";

const FORM_ID = "echeck";

class CustodyEcheq extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
        accounts: arrayOf(shape({})).isRequired,
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        currency: string,
        selectedAccount: shape({}).isRequired,
        hideDrawer: func.isRequired,
    };

    static defaultProps = {
        currency: "ARS",
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(accountsActions.listAllAccounts());
    }

    formatSelectorLabel = (account) =>
        `${i18n.get(`accounts.productType.${types[account.accountType]}`)} ····${account.accountNumber?.slice(-4)} ${
            account.accountType
        } ${account.currency}`;

    handleSelectAccount = (selected) => {
        const { dispatch } = this.props;
        dispatch(accountsActions.readAccount(selected));
    };

    componentDidUpdate(prevProps) {
        const wasFetching  = prevProps.fetching;
        const { accounts, hideDrawer, dispatch, currency, fetching } = this.props;
      
        if (wasFetching && !fetching)  {
            const accountsPesos = accounts?.filter((account) => account.currency === currency)
            .map((account) => ({
                value: account.productId,
                label: this.formatSelectorLabel(account),
                currency: i18n.get(`account.agreement.currency.${account.currency}`),
            }));

             // si no hay cuentas que matcheen la consulta entonces muestro snackbar y saco el drawer
            if (accountsPesos && accountsPesos.length == 0)
             {
                hideDrawer();
                const action = "CUSTODY";
                const msgs =  { "CURRENCY" : i18n.get(`echeq.currency.${currency}`), "ACTION" : i18n.get(`echeq.${action.toLowerCase()}.echeq`).toLowerCase()}
                dispatch(
                    notificationActions.showNotification(i18n.get("echeq.transaction.noAccountSameCurrency", null, msgs ), "error", ["menu"]),
                );
                return;
            }
        }       
    }

    render() {
        const { handleSubmit, accounts, fetching, currency } = this.props;
        const accountsPesos = accounts
            ?.filter((account) => account.currency === currency)
            .map((account) => ({
                value: account.productId,
                label: this.formatSelectorLabel(account),
                currency: i18n.get(`account.agreement.currency.${account.currency}`),
            }));
     
        return (
            <PageLoading loading={fetching}>
                {accountsPesos?.length > 0 && (
                    <div className="container">
                        <I18n id="custody.select.account" component="h2" />
                        <Form
                            className="above-the-fold"
                            onSubmit={(e) => {
                                handleSubmit(e);
                                e.stopPropagation();
                            }}>
                            <Col xs={12} md={8}>
                                <Field
                                    component={Selector}
                                    idForm={FORM_ID}
                                    name="custody"
                                    placeholder={i18n.get("global.select")}
                                    options={accountsPesos}
                                    onChange={this.handleSelectAccount}
                                />
                            </Col>

                            <Col md={8}>
                                <Button type="submit" bsStyle="primary" label="echeck.custody.select" />
                            </Col>
                        </Form>
                    </div>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    accounts: accountsSelectors.getAccounts(state),
    fetching: accountsSelectors.getFetching(state),
    selectedAccount: accountsSelectors.getSelectedAccount(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: (props) => ({
            deposit: "",
            selectedAccount: props.selectedAccount,
        }),
        validationSchema: () =>
            Yup.object().shape({
                custody: Yup.string().required(i18n.get("global.error.required")),
            }),
        handleSubmit: (filters, formikBag) => {
            const { dispatch, selectedAccount } = formikBag.props;
            dispatch(echeckActions.setEcheqsSpecialAttribute(selectedAccount?.uniformBankCode));
            dispatch(echeckActions.setEcheqsProductId(selectedAccount?.idProduct));
            dispatch(echeckActions.setEcheqsCreditAccountDescription(shortFormatAccountLabel(selectedAccount)));
            dispatch(push("/echecks/action/transaction/confirm"));
        },
    }),
)(CustodyEcheq);
